__turbopack_context__.v({
  "root": "AnswerButton-module__23IFoa__root",
});
